import React from 'react';
import { Link } from 'react-router-dom';
import { Widget } from '../Widget';
import { Badge } from '../../ui/Badge';
import { Button } from '../../ui/Button';
import { useDesignVariants } from '../../../contexts/DesignVariantContext';
import { intervalLabel, SURFACES } from '../../../data/designVariants';
import { useGovernance } from '../../../contexts/GovernanceContext';

/**
 * Reads the design variant service — it does not hold a second copy of that
 * configuration, own a timer, or decide anything. What it can honestly report
 * is the published POLICY per surface; which design a given visitor is being
 * shown is per-visitor by design, so this panel says that rather than naming
 * one design as "live everywhere".
 */
export function DesignVariantWidget() {
  const {
    configFor,
    ready,
    source,
    loadError,
    refresh
  } = useDesignVariants();
  const {
    allows
  } = useGovernance();
  const permitted = allows('experience.design.manage').allowed;
  if (!permitted) return null;
  const state = loadError ? 'error' : ready ? 'ready' : 'loading';
  return <Widget title="Design variants" description="What each surface is published to present." state={state} errorMessage={loadError ? 'The configuration service did not answer. Visitors are unaffected — each session continues on its last read.' : undefined} onRetry={refresh} action={<Link to="/admin/experience" data-id="element-493" data-mp="1c5ms9k9iy4uu">
          <Button variant="secondary" size="sm" data-id="element-494" data-mp="1c2ije9l46kxu">
            Configure
          </Button>
        </Link>} footnote={source === 'server' ? 'Server-backed — published configuration. Rotation position is per visitor, so two people may be seeing different designs within the same policy.' : 'This browser only — not published. Another browser or device sees the platform defaults.'} data-id="element-492" data-mp="1ux5u3nrtbcva">
      <ul className="space-y-2" data-id="element-495" data-mp="2rllobx5vaaeq">
        {SURFACES.map(surface => {
        const config = configFor(surface.key);
        const mode = config.mode === 'ROTATE' ? `Rotating every ${intervalLabel(config.rotationIntervalMs)}` : config.mode === 'DESIGN_1' ? 'Design 1 only' : 'Design 2 only';
        return <li key={surface.key} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-line bg-canvas px-3 py-2" data-id="element-496" data-mp="kx388rg4qbej">
              <div className="min-w-0" data-id="element-497" data-mp="18kuq0akfvgn7">
                <p className="truncate text-body-sm font-medium text-ink" data-id="element-498" data-mp="1dkpk0mzigmch">{surface.label}</p>
                <p className="truncate text-caption text-ink-subtle" data-id="element-499" data-mp="zmr5nhl6wpwz">{mode}</p>
              </div>
              {config.rotationPaused && config.mode === 'ROTATE' ? <Badge tone="warn" data-id="element-500" data-mp="3kc88s61ibcg2">Paused</Badge> : <Badge tone="ok" data-id="element-501" data-mp="3kax5e7bz46ph">Active</Badge>}
            </li>;
      })}
      </ul>
    </Widget>;
}